// const fullPhoto = (pid, order) => `/api/photos/full_photo/${pid}/${order}`
const API = process.env.NEXT_PUBLIC_IMAGE_SERVICE
// Ogłoszenie bez zdjęć (bez pid): obraz zastępczy zamiast …/photo/undefined/0 — usługa zdjęć odpowiada na taki
// adres pustym 200, a optymalizator obrazów Next (/_next/image) przerywa wtedy z błędem sharp
// „Input Buffer is empty” (500).
const FALLBACK = '/fallback/list.png'
// size: '1x' — 1024 × 681 (karty, miniatury); bez — największy wariant usługi, 2048 × 1362
const fullPhoto = (pid, order, size) => pid ? `${API}/photo/${pid}/${order ?? 0}${size ? `?s=${size}` : ''}` : FALLBACK

module.exports = fullPhoto
